import { createAsyncThunk } from "@reduxjs/toolkit";

import { type ChatChannelWithLastMessage } from "@fitness-app/data-models/entities/Chat";

import { getViewerId } from "../../../helpers/getViewerId";
import { type AsyncThunkCreator } from "../../../index";
import { CHAT_REDUCER_NAME } from "../types";
import { buildOrderedChatChannelsListQuery, type ChatChannelsListQueryParams } from "./buildChatChannelsListQuery";
import { subscribeToLatestChannel } from "./subscribeToLatestChannel";

export type FetchChatInitialListPagePayload = ChatChannelsListQueryParams;

export const fetchInitialChatListPage = createAsyncThunk<
  ChatChannelWithLastMessage[],
  FetchChatInitialListPagePayload,
  AsyncThunkCreator<string>
>(
  `${CHAT_REDUCER_NAME}/fetchInitialChatListPage`,
  async (payload, { rejectWithValue, getState, dispatch, extra: { db, auth } }) => {
    const viewerId = await getViewerId(auth);

    const { channelsSize } = getState().chat;

    const query = buildOrderedChatChannelsListQuery(db, viewerId, payload);

    const { error, data } = await query.limit(channelsSize).returns<ChatChannelWithLastMessage[]>();

    if (error) {
      return rejectWithValue(error.message);
    }

    dispatch(subscribeToLatestChannel());

    return data;
  },
);
